import React, { useMemo } from 'react';
import { matchPath, NavLink, resolvePath, useLocation, useResolvedPath } from 'react-router-dom';
import classlist from 'utils/classlist';

import './style.scss';

export interface NavItem {
    name: string;
    path?: string; // 如果path不存在，则降级成普通tab
}

export interface TabNavProps {
    navs: NavItem[];
    mode?: 'main' | 'lite';
    activeIndex?: number; // 从0开始，如果navs配置中无path，则读取该信息
    activeClassName?: string;
    className?: string;
    replace?: boolean;
    onClick?: (index: number) => void;
}

const TabNav: React.FC<TabNavProps> = ({
    mode = 'main',
    replace,
    activeClassName,
    onClick,
    navs,
    activeIndex = 0,
    className
}) => {
    const basePathname = useResolvedPath('').pathname;
    const location = useLocation();
    const needRoute = !!navs[0].path;
    const routeIndex = useMemo(() => {
        return navs.findIndex(
            item => !!matchPath(resolvePath(item.path || '', basePathname).pathname, location.pathname)
        );
    }, [location.pathname, navs, basePathname]);
    const curActiveIndex = needRoute ? routeIndex : (activeIndex as number);

    const handleClick = index => {
        onClick?.(index);
    };

    function render() {
        return (
            <>
                {navs.map((item, index) =>
                    needRoute ? (
                        <NavLink
                            to={item.path!}
                            key={item.path}
                            replace={replace}
                            onClick={() => handleClick(index)}
                            className={({ isActive }) =>
                                classlist(
                                    `${mode}-nav-item`,
                                    {
                                        active: isActive
                                    },
                                    isActive && activeClassName ? activeClassName : ''
                                )
                            }>
                            <div className="text">{item.name}</div>
                        </NavLink>
                    ) : (
                        <div
                            key={item.name}
                            onClick={() => handleClick(index)}
                            className={classlist(
                                `${mode}-nav-item`,
                                { active: curActiveIndex === index },
                                curActiveIndex === index ? activeClassName : ''
                            )}>
                            <div className="text">{item.name}</div>
                        </div>
                    )
                )}

                {mode === 'lite' && (activeIndex || 0) > -1 && (
                    <div
                        className={classlist('indicator', `${mode}-indicator`)}
                        style={{
                            left: `${((curActiveIndex + 0.5) / navs.length) * 100}%`
                        }}
                    />
                )}
            </>
        );
    }

    return <div className={classlist('tabnav-root', `${mode}-tabnav`, className)}>{render()}</div>;
};

export default TabNav;
